import React from 'react';

import { t } from 'i18next';

import BdsInput from '../../../../../../../shared/components/v3/BdsInput/BdsInput';
import BdsTextArea from '../../../../../../../shared/components/v3/BdsTextArea/BdsTextArea';
import { IChallengeDescriptionForm } from '../../../../../../../shared/interfaces/challenges';
import { TRANSLATION_CHALLENGES } from '../../../../../../../shared/translations/challenges';

import './ChallengeDescriptionForm.scss';

const ChallengeDescriptionForm = ({
  title,
  description,
  onChangeTitle,
  onChangeDescription
}: IChallengeDescriptionForm) => {
  const titleLimit = 20;
  const descriptionLimit = 140;
  const tTitle = t(TRANSLATION_CHALLENGES.description.title);
  const tDescription = t(TRANSLATION_CHALLENGES.description.description);
  const placeHolderTitle = t(TRANSLATION_CHALLENGES.description.title_placeholder);
  const placeHolderDescription = t(TRANSLATION_CHALLENGES.description.description_placeholder);
  const helperTextTitle = t(TRANSLATION_CHALLENGES.description.helper_text, {
    character_used: title.length,
    character_max: titleLimit
  });
  const helperTextDescription = t(TRANSLATION_CHALLENGES.description.helper_text, {
    character_used: description.length,
    character_max: descriptionLimit
  });
  const handleTitleChange = (v: string) => {
    onChangeTitle(v.slice(0, titleLimit));
  };

  const handleDescriptionChange = (v: string) => {
    onChangeDescription(v.slice(0, descriptionLimit));
  };
  return (
    <div className="describe-challenge-form">
      <div className="f-label l-title">{tTitle}</div>
      <BdsInput
        hintText={placeHolderTitle}
        helperText={helperTextTitle}
        onChanged={handleTitleChange}
        maxLength={titleLimit}
        initValue={title}
      />
      <div className="f-label l-description">{tDescription}</div>
      <BdsTextArea
        hintText={placeHolderDescription}
        helperText={helperTextDescription}
        onChanged={handleDescriptionChange}
        maxLength={descriptionLimit}
        initialValue={description}
        maxDisplayedLines={3}
        maxExpandableLines={3}
      />
    </div>
  );
};

export default ChallengeDescriptionForm;
